import { useEffect } from 'react';

import {
  useLinkTextToAvoidInJobSearchesActions
} from './LinkTextToAvoidInJobSearchesContext';

import {
  getLinkTexts,
} from './restApi';

const LinkTextToAvoidInJobSearchesLoader = () => {
  const { initializeState, onResponse, onError } = useLinkTextToAvoidInJobSearchesActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getLinkTexts({
      onResponse,
      onError,
    });
  }, []);

  return null;
};

export default LinkTextToAvoidInJobSearchesLoader;
